<template>
  <div class="main xp">
    <h1 class="page-title">Experience</h1>
    <div class="card-container">
      <xp-card
        v-for="card in cards"
        :key="card.name"
        :data="card"
      />
    </div>
  </div>
</template>

<script>
import xpCard from './ExperienceCard.vue';
import { experiences } from '@/data/experience';

export default {
  name: 'Experience',
  components: {
    'xp-card': xpCard
  },

  data () {
    return {
      cards: experiences
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";

.xp {
  .card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}

@media only screen and (min-width: $desktop-lg) {

}
</style>
